export function not(value: boolean) {
	return !value;
}
export function notNull<T>(value: T | null): boolean {
	return value !== null;
}
